export const FormsTabs = ({ selectedTab, tabs, setCurrentTab }) => {
  const totalTabs = tabs.length;

  return (
    <ul className="nav nav-tabs">
      {tabs.map((name, index) => {
        const tab = index + 1;

        const isActive = selectedTab === tab;
        const isDisabled = selectedTab < tab;

        const className = `cursor-pointer ${isActive ? "active" : isDisabled ? "disabled" : ""}`;

       

        return (
          <li
            key={index}
            className={className}
            // onClick={() => setCurrentTab(tab)}
          >
            <span
              data-toggle="tab"
              className="d-flex text-dark font-weight-700 line-height-12"
            >
              <div className="round" />
              <div className="wizard-tab-title">
                <span className="text-light-default font-10 font-weight-600">
                  Step {index + 1}/{totalTabs}
                </span>
                <br />
                {name}
              </div>
            </span>
          </li>
        );
      })}
    </ul>
  );
};
